
import {
  ref,
  defineComponent,
  watch,
  computed,
} from 'vue';
import { useStore, } from 'vuex';

import History from './components/history.vue';
import Defualt from './components/defualt.vue';

import {
  Modal,
} from 'ant-design-vue';

export default defineComponent({
  components: {
    Modal,
    History,
    Defualt,
  },
  props: {
    particularsVisible: {
      type: Boolean,
      default: () => false,
    },
    selectOrderCode: {
      type: String,
      default: () => '',
    },
    action: {
      type: String,
      default: () => '',
    },
  },
  emits: ['update:particularsVisible',],
  setup (props, context) {
    const store = useStore();
    const ok = () => null;

    const close = () => {
      context.emit('update:particularsVisible', !props.particularsVisible);
      // 关闭弹窗清空ticketDetail，打开弹窗时再重新获取
      store.commit('ticket/setStateItem', { value: {}, type: 'ticketDetail', });
    };

    const getDetail = (val: string) => {
      store.dispatch('ticket/getRepairOrderInfoById', {
        repairOrderId: val,
      });
    };
    const changeDetail = () => {
      setTimeout(() => {
        getDetail(props.selectOrderCode);
      },1000);
    };

    const ticketDetail = computed(() => store.state.ticket.ticketDetail);

    const titles = ref<string>('工单详情');

    return {
      ticketDetail,
      getDetail,
      ok,
      close,
      changeDetail,
      titles,
    };
  },
});
